import DualloInspectionZoneClient from "@/clients/duallo/DualloInspectionZoneClient";

class InspectionAreaService {
    async getInspectionAreaMarkersByScanId(scanId){
        return await DualloInspectionZoneClient.getInspectionAreasByScanId(scanId);
    }

    async getInspectionAreaMarkersAsync(assetId){
        return await DualloInspectionZoneClient.getInspectionAreasByAssetId(assetId);
    }

    async getInspectionAreaMarkersCount(assetId){
        const zones = await DualloInspectionZoneClient.getInspectionAreaMarkersByAssetIdAsync(assetId);
        return zones.length;
    }

    async createInspectionAreaAsync(request){
        return await DualloInspectionZoneClient.createInspectionArea(request);
    }
    
    async updateInspectionArea(area){
        return await DualloInspectionZoneClient.updateInspectionArea(area);
    }

    async deleteInspectionZoneAsync(inspectionZone) {
        return await DualloInspectionZoneClient.deleteInspectionZone(inspectionZone.scanId, inspectionZone.id);
    }

    async getInspectionZoneByScanId(scanId, id){
        return await DualloInspectionZoneClient.getInspectionZoneByScanId(scanId, id);     
    }
}

export default new InspectionAreaService();